import styled from "styled-components";
import {
  Underlinelink,
  InputWrapper,
  InputWrapperDrop,
  PillButtonAdd
} from "../../styles";
import { Err } from "../../styles";

export const UnderlinelinkSpace = styled(Underlinelink)`
  margin-left: 30px;
  line-height: 40px;
  vertical-align: middle;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: -10px 0 20px 4%;
  }
`;

export const InputWrapperWrap = styled(InputWrapper)`
  margin-bottom: -4px;
`;

export const InputWrapperDropWrap = styled(InputWrapperDrop)`
  margin-bottom: 6px;
`;

export const PillButtonAddSpace = styled(PillButtonAdd)`
  margin-bottom: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0;
    margin-bottom: 40px;
  }
`;

export const ErrMargin = styled(Err)`
  margin-top: 8px;
`;
export const RelatedContributerNote = styled(Err)`
  margin-top: 8px;
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;
export const ErrRelation = styled(Err)`
  margin-top: -1px;
`;

export const MainWrap = styled.div`
  margin-bottom: 16px;
`;

export const ButtonMargin = styled.div`
  margin-top: -16px;
`;

export const DividerWrap = styled.div`
  .ant-divider {
    background: #d4d4d4;
  }
`;


export const SubContentWrap = styled.div`
  margin: 11px 0px 15px 0px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary}; 
`;


export const AnchorLink = styled.div`
  color : ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  margin-bottom: 50px;
  cursor: pointer;
`;  